import IconClose from "@/assets/icons/close.svg?react";
import "./styles/button-close.scss";
import { useTranslation } from "react-i18next";

type Props = {
  size?: `default` | `smaller`;
  onClick: () => void;
  className?: string;
}

const ButtonClose = ({ size = `default`, onClick, className, ...rest }: Props) => {
  const { t } = useTranslation();

  const classes = [
    `ws-widgets-button-close`,
    `ws-widgets-button-close--${ size }`,
    className,
  ];

  return (
    <button
      type={ `button` }
      className={ classes.join(` `) }
      onClick={ onClick }
      aria-description={ t(`core.close`) }
      { ...rest }
    >
      { t(`core.close`) }
      <IconClose/>
    </button>
  )
}

export default ButtonClose;
